import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import OutsideClickHandler from 'react-outside-click-handler';
import "./Header.css";
import SideBar from "../Sidebar/SideBar";

function Header(props) {
    const [isDDBox, setIsDDBox] = useState(false);
    const [isCusName, setIsCusName] = useState("");
    const [isMobileNo, setIsMobileNo] = useState("");
    const [isSticky, setIsSticky] = useState(false);
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(true);

    // const{storeLogin}=useAuthDataContext()

    const handleToggleDD = () => {
        setIsDDBox(!isDDBox);
    };

    const handleSignOut = () => {
        localStorage.removeItem("smc-csp-token");
        localStorage.removeItem("smc-csp-customer-name");
        localStorage.removeItem("MobileNo");
        navigate("/"); // Redirect to login page
        window.location.reload(); // Reload the page to clear cached state
    };
    useEffect(() => {
        const customerName = localStorage.getItem("smc-csp-customer-name");
        const MobileNo = localStorage.getItem("MobileNo");
        if (customerName) {
            setIsCusName(customerName);
            setIsMobileNo(MobileNo);
        }
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    useEffect(() => {
        const checkScreenSize = () => {
            setIsVisible(window.innerWidth > 768);
        };

        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);

        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);
    return (
        <div className={`header ${isSticky ? "sticky" : ""}`}>
            {!isVisible &&
                <SideBar />    
            }

            <div className="Contai">
                <div className="profile" onClick={handleToggleDD}>
                    <div className="img-box">
                        <img src="https://www.smcinsurance.com/myaccount/js/assets/Images/profile-pic.jpg" alt="profile-pic" title="Profile" />
                    </div>
                    <div className="user">
                        <h3>
                            {isCusName} <i className="fas fa-chevron-down"></i>
                        </h3>
                    </div>
                </div>
                <OutsideClickHandler onOutsideClick={() => { setIsDDBox(false) }}>
                {isDDBox && (
                    <div className="menu">
                        <ul>
                            {/*<li>*/}
                            {/*    <NavLink to="/profile">*/}
                            {/*        <i className="ph-bold ph-user"></i>&nbsp;Profile*/}
                            {/*    </NavLink>*/}
                            {/*</li>*/}
                            <li>
                                <NavLink onClick={handleSignOut}>
                                    <i className="ph-bold ph-sign-out"></i>&nbsp;Sign Out
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    )}
                </OutsideClickHandler>
            </div>
        </div>
    );
}

export default Header;
